import { colors } from 'utils/constants';
import RoundedButton from 'components/RoundedButton';
import Subheading, { SubheadingColourScheme } from 'components/Subheading';

const PrizeModal = ({ heading, backgroundImage, includesList, handleDismiss }) => (
	<div className='container' id='dimmedBackground' onClick={(e) => e.target.id === 'dimmedBackground' && handleDismiss()}>
		<div className='message'>
			<div className='heroSection'>
				<Subheading Tag='h4' className="rafflePrizeCardTitle" colourScheme={SubheadingColourScheme.WHITE_TEXT_BLACK_SHADOW}>
					{heading}
				</Subheading>
			</div>

			<div className='paddedMaxWidthContainer'>
				<h4 style={{ textAlign: 'left', width: '100%', margin: '1em 0 1em 0', color: colors.primaryBrandGray }}>
					INCLUDES
				</h4>

				<ul>
					{ includesList.map((includedItem, i) =>
						<li key={i}>{includedItem}</li>
					)}
				</ul>

				<RoundedButton onClick={handleDismiss} className='doneButton' >
					CLOSE
				</RoundedButton>
			</div>
		</div>

		<style jsx>{`
			.container {
				position: fixed;
				top: 0;
				left: 0;
				width: 100%;
				max-width: 100%;
				height: 100%;
				background-color: rgba(55,55,55,0.5);
				z-index: 999;
			}
			
			.message {
				position: fixed;
				top: 50%;
				left: 50%;
				width: 95%;
				max-width: 600px;
				max-height: 95%;
				overflow-y: auto;
				-webkit-transform: translate(-50%, -50%);
				transform: translate(-50%, -50%);

				display: flex;
				flex-direction: column;
				align-items: center;
				border-radius: 5px;
				box-shadow: 2px 2px 12px rgba(55,55,55,0.6);
				background-color: white;
				z-index: 1000;
			}
			
			.heroSection {
				background-image: url(${backgroundImage});
				background-size: cover;
				background-position: center;
				width: 100%;
				min-height: 110px;
				flex-shrink: 0;
				box-shadow: inset 0 0 0 1000px rgba(0,0,0,.6);
				padding: 3em;
				display: flex;
				flex-direction: column;
			}
			
			:global(.message .subheading.rafflePrizeCardTitle) {
				font-size: 1.5rem;
				text-align: left;
			}
			
			h2, h5 {
				color: white;
				text-align: left;
				text-shadow: 0 0 6px black;
			}
			
			ul {
				width: 100%;
				padding-left: 2em;
				margin: 0;
			}
			
			:global(.doneButton) {
				position: relative;
				min-width: 210px;
				justify-self: center;
				margin: 20px;
			}
			
			// This is needed to add padding below the button when scrolling is enabled on the parent div.
			:global(.doneButton:after) {
				content: "";
				display: block;
				position: absolute;
				bottom: -2rem;
				width: 1px;
				height: 2rem;
			}
		`}</style>
	</div>
);

export default PrizeModal;
